import React from 'react';
import { sprintf } from 'sprintf';
import { flatten } from 'lodash';

import * as Types from 'types';
// @ts-ignore
import { Carousel } from 'components/carousel/Carousel';
// @ts-ignore
import { CarouselItem } from 'components/carousel/CarouselItem';
import { ArtworkPlayer } from 'artworkPlayer';

type Props = {
  artwork: Types.ArtworkDetails;
};

export const ArtworkDetailMediaPreview: React.FC<Props> = ({ artwork }) => {
  if (artwork.bundledPhysicalObjects.length) {
    const images = flatten(
      artwork.bundledPhysicalObjects.map((bundledPhysicalObject) => bundledPhysicalObject.images),
    );

    return (
      <Carousel navigationNode={$('.js-artwork-detail__before-content')[0]}>
        {[
          <CarouselItem key='player' previewImageUrl={artwork.thumbnailUrl}>
            <ArtworkPlayer artwork={artwork} />
          </CarouselItem>,
          ...images.map(({ large }) => (
            <CarouselItem key={large} previewImageUrl={large}>
              <img src={large} alt={sprintf('Preview of %s', artwork.title)} />
            </CarouselItem>
          )),
        ]}
      </Carousel>
    );
  }

  return <ArtworkPlayer artwork={artwork} />;
};
